<template>
  <div class="register index">
    <img class="bg" src="http://img.wish.hebyun.com.cn/images/login_bg.jpg" />
    <div class="header">
      <div class="title_big">党员帮办微心愿</div>
      <div class="title_small">欢迎认证党员~</div>
    </div>
    <div class="form_section">
      <div class="form_item">
        <input placeholder="请输入姓名" v-model="name" />
      </div>
      <div class="form_item">
        <input placeholder="请输入电话" v-model="mobile" />
      </div>
      <div class="form_item" @click="showPopup">
        <input placeholder="请选择地区" v-model="address" disabled />
      </div>
      <div class="form_item">
        <input placeholder="请输入单位" v-model="unit_name" />
      </div>
    </div>

    <img
      class="bgbottom"
      src="http://img.wish.hebyun.com.cn/images/login_bg_footer.png"
    />
    <Button :button="button" @click.native="registerBtn" />
    <!--勾选-->
    <Checkbox @changeState="change($event)">
      <span slot="checkText"
        >上述信息是我本人填写，本人对信息的真实性和完整性负责。</span
      >
    </Checkbox>
    <!--弹出层-->
    <van-popup v-model="showPop" round position="bottom">
      <van-picker
        title="地区"
        show-toolbar
        value-key="name"
        :columns="region"
        @confirm="handleConfirm"
        @cancel="handleCancle"
      />
    </van-popup>
   
  </div>
</template>

<script>
import Button from "@/components/Button";
import Checkbox from "@/components/Checkbox";

export default {
  name: "register",
  components: {
    Button,
    Checkbox

  },
  data() {
    return {
      message: "",
      showPop: false,
      region: [],
      address: "",
      button: "认证",
      area: "",
      city: "",
      name: "",
      mobile: "",
      unit_name: "",
      checked: true, //复选框状态
    };
  },
  created() {
    this.queryRegion();
  },
  mounted() {},
  methods: {
    // 点击认证按钮
    registerBtn() {
      if (this.name.trim().length === 0) {
        this.$toast("姓名不能为空");
        return;
      }
      if (this.mobile.trim().length === 0) {
        this.$toast("请输入电话");
        return;
      }
      if (this.address.trim().length === 0) {
        this.$toast("请选择地区");
        return;
      }
      if (this.unit_name.trim().length === 0) {
        this.$toast("请输入单位");
        return;
      }
      if (this.checked === false) {
        this.$toast("请您勾选下方复选框");
        return;
      }
      let data = {
        name: this.name,
        mobile: this.mobile,
        city: this.city,
        area: this.area,
        unit_name: this.unit_name,
      };
      this.$api.partyRegister(data);
      this.$toast("认证成功");
      setTimeout(() => {
        this.$router.push("./mine");
      }, 2000);
    },
    showPopup() {
      this.showPop = true;
    },
    handleCancle() {
      this.showPop = false;
    },
    handleConfirm(e) {
      this.address = e[0] + "·" + e[1];
      this.city = e[0];
      this.area = e[1];
      this.showPop = false;
    },
    // 查询地区
    async queryRegion() {
      let { data } = await this.$api.queryLevelRegion();
      this.region = data;
    },
    // 接收复选框状态
    change(data) {
      this.checked = data;
    },
  },
};
</script>
<style lang="scss">
.register {
  .btn {
    width: 300px !important;
    height: 42px !important;
    margin: 52px auto 16px !important;
  }
  .bgbottom {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
  }
}
</style>
<style scoped lang="scss">
.index {
  width: 100%;
  background-color: #ffffff !important;
  height: 100vh;
  overflow: hidden;
  position: relative;
  .bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }
  .header {
    width: 100%;
    text-align: center;
    padding-top: 50px;
    padding-bottom: 20px;
    color: #ffffff;
    position: relative;
    .title_big {
      font-size: 31px;
      margin-bottom: 13px;
    }

    .title_small {
      font-size: 21px;
    }
  }

  .form_section {
    padding: 0 37.5px;
    box-sizing: border-box;
    position: relative;
    z-index: 20;
    .form_item {
      padding-top: 38px;
      input::-webkit-input-placeholder {
        color: rgba(202, 9, 8, 0.6);
      }
      input {
        display: block;
        width: 100%;
        background-color: transparent;
        border: none;
        outline: none;
        font-size: 14px;
        color: #cb0a08;
        padding-bottom: 8px;
        border-bottom: 1px solid rgba(202, 9, 8, 0.6);
      }
    }
  }

  /deep/.van-picker__title {
    line-height: normal;
  }
}
</style>
